/**
 * * @module component/filter.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import Bootstrap from "bootstrap";
import Moment from "moment";
import BootstrapDatePicker from "bootstrap-datepicker";
import $ from "jquery";
import _ from "underscore";
import Tooltip from "../components/tooltip";

const Filter = Backbone.View.extend({
  el: $(document),

  events: {
    "click .filters-clear-button": "clearFilters",
    "click .access-checkbox": "applyAccessFilter",
    "click .categories .category": "applyCategoriesFilter",
    "click .news-tags-button": "applyNewsTagFilter",
    "click .show-checkbox": "applyShowFilter",
    "click .events-show-more": "pagination",
    "click #member": "applyMembersFilter",
    "click #classes": "applyClassesList",
    "click #family-friendly": "applyFamilyFilter"
  },

  currentFilter: {},

  initialInstaces: [],

  instanceEl: undefined,

  containerEl: undefined,

  calendarClick: 0,

  startDate: undefined,

  endDate: undefined,

  initialize: function (instanceEl, containerEl) {
    this.instanceEl = instanceEl;
    this.containerEl = containerEl;
    this.render();

    if ($("body").hasClass("page-template-whatson") || $("body").hasClass("page-template-page-news-list")) {
      this.getAllUrlParams();
    }

  },

  getInitialInstaces: function () {
    this.$initialInstaces = $(this.instanceEl);
  },

  getAllUrlParams: function(url) {
    // get query string from url (optional) or window
    let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    const obj = {};

    // if query string exists
    if (queryString) {

      // stuff after # is not part of query string, so get rid of it
      queryString = queryString.split('#')[0];

      // split our query string into its component parts
      const arr = queryString.split('&');

      for (let i = 0; i < arr.length; i++) {
        // separate the keys and the values
        const a = arr[i].split('=');

        // set parameter name and value (use 'true' if empty)
        let paramName = a[0];
        let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

        // (optional) keep case consistent
        // paramName = paramName.toLowerCase();
        // if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

        // if the paramName ends with square brackets, e.g. colors[] or colors[2]
        if (paramName.match(/\[(\d+)?\]$/)) {

          // create key if it doesn't exist
          var key = paramName.replace(/\[(\d+)?\]/, '');
          if (!obj[key]) obj[key] = [];

          // if it's an indexed array e.g. colors[2]
          if (paramName.match(/\[\d+\]$/)) {
            // get the index value and add the entry at the appropriate position
            var index = /\[(\d+)\]/.exec(paramName)[1];
            obj[key][index] = paramValue;
          } else {
            // otherwise add the value to the end of the array
            obj[key].push(paramValue);
          }
        } else {
          // we're dealing with a string
          if (!obj[paramName]) {
            // if it doesn't exist, create property
            obj[paramName] = paramValue;
          } else if (obj[paramName] && typeof obj[paramName] === 'string'){
            // if property does exist and it's a string, convert it to an array
            obj[paramName] = [obj[paramName]];
            obj[paramName].push(paramValue);
          } else {
            // otherwise add the property
            obj[paramName].push(paramValue);
          }
        }
      }
    }

    for(var f in obj){
      this.addToFiltersList(f, obj[f], true);
    }
  },

  addMinPrice: function (num) {
    this.addToFiltersList("minPrice", num);
  },

  addMaxPrice: function (num) {
    this.addToFiltersList("maxPrice", num);
  },


  addToFiltersList: function (key, value, fromURl = false) {
    var _this = this;

    if (key == "access" || key == "category") {
      if (typeof this.currentFilter[key] == "undefined") {
        _this.currentFilter[key] = [];
      }

      if( key == "category") {
        if(value.includes(',')){
          let categories = value.split(",");
          for ( let i = 0; i <= categories.length; i++){
            if(categories[i] != undefined){
              _this.currentFilter[key].push(categories[i]);
              $(`.category[data-category=${categories[i]}]`).addClass("applied");
            }
          }
        }else {
        _this.currentFilter[key].push(value);
        }
      } else {
        _this.currentFilter[key].push(value);
      }

    } else {
      _this.currentFilter[key] = value;
    }
    
    _this.applyFilter();

    if (fromURl == true){
      if ( key == "access") {
        $(`:checkbox[value=${value}]`).prop("checked",true);
      } else if ( key == "member" ) {
        $("#member").prop("checked",true);
      } else if ( key == "classes" ) {
        $("#classes").prop("checked",true);
      } else if ( key == "family-friendly" ) {
        $("#family-friendly").prop("checked",true);
      } else if( key == "tag" ) {
        $(`.news-tags-button[data-tag=${value}]`).addClass("applied");
      }
    }
  },

  clearFilters: function (e) {
    const _this = this;

    e.preventDefault();
    _this.currentFilter = {};
    $(".access-checkbox").prop("checked", false).removeClass("applied");
    $(".show-checkbox").prop("checked", false).removeClass("applied");
    // doesn't work
    // $(".calendar-range").val("").datepicker("update");
    // this works instead
    $(".calendar-range").each(function () {
      delete _this.currentFilter.start;
      delete _this.currentFilter.end;
      $(this).datepicker("clearDates");
    });

    $(".categories .category").removeClass("applied");
    _this.applyFilter(true);
  },

  applyFilter: function (resetCalendar = false) {

    const _this = this;
    const filters = _this.currentFilter;

    let instances = _this.$initialInstaces;
    const $container = $(this.containerEl);
    const $noReultsContainer = $(".no-results");
    let params = '';

    //no URL update required
    if (filters["minPrice"] != undefined && filters["maxPrice"] != undefined) {
      instances = instances.filter(function (index, element) {
        const $event = $(element);
        let match = [];
        // var eventMinPrice = $event.data("min-price");
        // var eventMaxPrice = $event.data("max-price");
        let prices = $event.data("prices");
        if (prices && prices.length > 0) {
          prices = prices.split(",");

          match = prices.some(function (index, num) {
            return (parseInt(index, 10) >= parseInt(filters["minPrice"], 10) && parseInt(index, 10) <= parseInt(filters["maxPrice"],10));
          });
        }else{
          match = (prices >= filters["minPrice"] && prices <= filters["maxPrice"]);
        }

        return match
      });
    }

    if (filters["access"] != undefined) {
      instances = instances.filter(function (index, element) {
        var $event = $(element);
        var access = $event.data("access");
        if (access.length > 0) {
          var match = false;
          access = access.split(",");

          for (var $i = 0; $i <= access.length; $i++) {
            if (filters["access"].includes(access[$i])) {
              return true;
            }
          }
        }
      });

      if (params.length >= 1){
        params = params + "&access=" + filters["access"]
      }else{
        params = "access=" + filters["access"]
      }
    }

    if (filters["category"] != undefined) {
      instances = instances.filter(function (index, element) {
        var $event = $(element);
        var cat = $event.data("categories");
        if (cat.length > 0) {
          cat = cat.split(",");

          for (var $i = 0; $i <= cat.length; $i++) {
            if (filters["category"].includes(cat[$i])) {
              return true;
            }
          }
        }
      });

      if (params.length >= 1){
        params = params + "&category=" + filters["category"]
      }else{
        params = "category=" + filters["category"]
      }
    }
  
    if (filters["tag"] != undefined) {
      instances = instances.filter(function (index, element) {
        var $event = $(element);
        var tag = $event.data("tag");

        return tag == filters["tag"];
      });
      if (params.length >= 1){
        params = params + "&tag=" + filters["tag"]
      }else{
        params = "tag=" + filters["tag"]
      }
    }

    //no URL update required
    if (filters["accessOnly"] != undefined) {
      instances = instances.filter(function (index, element) {
        var $event = $(element);
        var access = $event.data("access");

        return access.length > 0;
      });
    }

    if (filters["member"] != undefined) {
      instances = instances.filter(function (index, element) {
        var $event = $(element);
        var member = $event.data("member");
        return member === 1;
      });
      if (params.length >= 1){
        params = params + "&member=" + filters["member"]
      }else{
        params = "member=" + filters["member"]
      }
    }

    if (filters["course"] != undefined) {
      instances = instances.filter(function (index, element) {
        var $event = $(element);
        var course = $event.data("course");
        return course === 1;
      });
      if (params.length >= 1){
        params = params + "&course=" + filters["course"]
      }else{
        params = "course=" + filters["course"]
      }
    }

    if (filters["family"] != undefined) {
      instances = instances.filter(function (index, element) {
        var $event = $(element);
        var family = $event.data("family");
        return family === 1;
      });
      if (params.length >= 1){
        params = params + "&family=" + filters["family"]
      }else{
        params = "family=" + filters["family"]
      }
    }
    
    if (
      (filters["start"] || isNaN(filters["start"]) == false) &&
      (filters["end"] != undefined || isNaN(filters["end"]) == false) &&
      resetCalendar == false
      // && filters["end"] > filters["start"]
    ) {
      instances = instances.filter(function (index, element) {
        var $event = $(element);
        // var start = new Date($event.data("date-start"));
        // var end = new Date($event.data("date-end"));

        var start = Moment($event.data("date-start")).toDate();
        var end = Moment($event.data("date-end")).toDate();
        
        return (
          (filters["start"] >= start && filters["start"] <= end) ||
          (start >= filters["start"] && start <= filters["end"])
        );
      });
    }

    $container.empty();
    $container.append(instances);

    if (Object.keys(filters).length === 0 && filters.constructor === Object) {
      $(".pagination").show();
    } else {
      $(".pagination").hide();
    }

    if (instances.length == 0) {
      $noReultsContainer.show();
    } else {
      $noReultsContainer.hide();
    }

    // console.log('params::', params)
    let hash = '';
    if ( '#book' == window.location.hash ) {
      hash = '#book';
    }
    if( params.length >= 1 ){
      //update URL
      var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + params + hash;
    }else{
      refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + hash;
    }
    window.history.pushState({ path: refresh }, '', refresh); 

  },

  applyMembersFilter: function (e) {
    var _this = this;
    var $target = $(e.target);
    var filterToApply = $target.data("member");

    if ($target.hasClass("applied")) {
      delete _this.currentFilter["member"];
      _this.applyFilter();
      $target.removeClass("applied");
    }else {
      _this.addToFiltersList("member", filterToApply);
      $target.addClass("applied");
    }
  },

  applyClassesList: function (e) {
    var _this = this;
    var $target = $(e.target);
    var filterToApply = $target.data("course");

    if ($target.hasClass("applied")) {
      delete _this.currentFilter["course"];
      _this.applyFilter();
      $target.removeClass("applied");
    } else {
      _this.addToFiltersList("course", filterToApply);
      $target.addClass("applied");
    }
  },

  applyFamilyFilter: function(e){
    var _this = this;
    var $target = $(e.target);
    var filterToApply = $target.data("family");

    if ($target.hasClass("applied")) {
      delete _this.currentFilter["family"];
      _this.applyFilter();
      $target.removeClass("applied");
    } else {
      _this.addToFiltersList("family", filterToApply);
      $target.addClass("applied");
    }
  },

  applyCategoriesFilter: function (e) {
    var _this = this;
    var $target = $(e.target);
    var filterToApply = $target.data("category");

    if ($target.hasClass("applied")) {
      _this.currentFilter["category"] = _this.currentFilter["category"].filter(function (value, index, arr) { 
        return value != filterToApply; 
      });
      if(_this.currentFilter["category"].length == 0){
        delete _this.currentFilter["category"];
      }
      _this.applyFilter();
      $target.removeClass("applied");
    } else {
      _this.addToFiltersList("category", filterToApply);
      $target.addClass("applied");
    }

  },

  applyNewsTagFilter: function (e) {
    var _this = this;
    var $target = $(e.target);
    var filterToApply = $target.data("tag");

    if ($target.hasClass("applied")) {
      delete _this.currentFilter["tag"];
      _this.applyFilter();
      $target.removeClass("applied");
    } else {
      $('.news-tags-button').removeClass('applied');
      _this.addToFiltersList("tag", filterToApply);
      $target.addClass("applied");
    }
  },

  applyShowFilter: function (e) {
    var _this = this;
    var $target = $(e.target);
    var filterToApply = $target.val();

    if ($target.hasClass("applied")) {
      _this.currentFilter["show"] = _this.currentFilter["show"].filter(function (value, index, arr) {
        return value != filterToApply;
      });
      if (_this.currentFilter["show"].length == 0) {
        delete _this.currentFilter["show"];
      }
      _this.applyFilter();
      $target.removeClass("applied");
    } else {
      _this.addToFiltersList("show", filterToApply);
      $target.addClass("applied");
    }
  },

  applyAccessOnlyFilter: function (e) {
    var _this = this;
    var $target = $(e.target);
    var filterToApply = "true";

    if ($target.hasClass("applied")) {
      delete _this.currentFilter["accessOnly"];
      _this.applyFilter();
      $target.removeClass("applied");
    } else {
      _this.addToFiltersList("accessOnly", filterToApply);
      $target.addClass("applied");
    }
  },

  applyAccessFilter: function (e) {
    var _this = this;
    var $target = $(e.target);
    var filterToApply = $target.val();

    if ($target.hasClass("applied")) {
      _this.currentFilter["access"] = _this.currentFilter["access"].filter(function (value, index, arr) {
        return value != filterToApply;
      });
      if (_this.currentFilter["access"].length == 0) {
        delete _this.currentFilter["access"];
      }
      _this.applyFilter();
      $target.removeClass("applied");
    } else {
      _this.addToFiltersList("access", filterToApply);
      $target.addClass("applied");
    }
  },

  applyPriceFilter: function (e) {
    var _this = this;
    var $target = $(e.target);
    var filterToApply = $target.data("filter");

    if ($target.hasClass("applied")) {
      delete _this.currentFilter.price;
      _this.applyFilter();
      $target.removeClass("applied");
    } else {
      _this.addToFiltersList("price", filterToApply);
      $target.addClass("applied");
    }
  },

  applySelectFilters: function () {
    var _this = this;

    $(".calendar-range").on("changeDate", function (e) {

      if($(".calendar-range-start").datepicker("getFormattedDate") != '' && $(".calendar-range-end").datepicker("getFormattedDate") != ''){
          var start = new Date(
            new Date(
              $(".calendar-range-start").datepicker("getFormattedDate")
            ).getFullYear(),
            new Date(
              $(".calendar-range-start").datepicker("getFormattedDate")
            ).getMonth(),
            new Date(
              $(".calendar-range-start").datepicker("getFormattedDate")
            ).getDate()
          );
          var end = new Date(
            new Date(
              $(".calendar-range-end").datepicker("getFormattedDate")
            ).getFullYear(),
            new Date(
              $(".calendar-range-end").datepicker("getFormattedDate")
            ).getMonth(),
            new Date(
              $(".calendar-range-end").datepicker("getFormattedDate")
            ).getDate()
          );

          if (
            $(e.target).hasClass("calendar-range-end") &&
            _this.calendarClick > 0 &&
            _this.calendarClick % 2 === 0
          ) {
            delete _this.currentFilter.start;
            delete _this.currentFilter.end;

            $(".calendar-range").each(function () {
              _this.calendarClick = 1;
              // causes bug
              // $(this).datepicker("clearDates");

              jQuery(".calendar-range-start").data().datepicker.setDates(end);
              jQuery(".calendar-range-end").data().datepicker.setDates(end);
            });

            _this.addToFiltersList("start", end);
            _this.addToFiltersList("end", end);
          } else {
            _this.addToFiltersList("start", start);
            _this.addToFiltersList("end", end);
          }

          if ($(e.target).hasClass("calendar-range-end")) {
            _this.calendarClick++;
          }
        }
      });

    // $(".calendar-range").on("clearDate", function (e) {
    //   delete _this.currentFilter.start;
    //   delete _this.currentFilter.end;

    //   $(".calendar-range input").each(function () {
    //     console.log($(this));
    //     $(this).datepicker("clearDates");
    //   });

    // });
  },

  calendar: function () {
    var startDate = new Date();
    var endDate = new Date(new Date().setFullYear(startDate.getFullYear() + 2));

    $(".calendar-range").datepicker({
      inputs: $(".calendar-range-start, .calendar-range-end"),
      format: "yyyy-mm-dd",
      startDate: startDate,
      endDate: endDate,
      weekStart: 1,
      maxViewMode: 0,
      clearBtn: false,
      yearRange: "2002:2012",
      templates: {
        leftArrow: '<span class="icon-arrow-left"></span>',
        rightArrow: '<span class="icon-arrow-right"></span>',
      },
    });
  },

  pagination: function (e) {
    var _this = this;
    var el = $(e.currentTarget);
    e.preventDefault();
    var url = el.attr("href");
    var items = undefined;
    var data = {
      ajax: true,
    };

    $.post(url, data, function (response) {
      items = $(response).html();
      if ($("body").hasClass("page-template-whatson")) {
        el.parent().prev(".overview").append(items);
      } else {
        $(".child-pages", el.parent().prev()).append(items);
      }
      let position = 0;

      if($(`#page-${el.data("page")}-item-1`)){

        if ($(".header.scrolled").length > 0) {
          position = $(`#page-${el.data("page")}-item-1`).offset().top - $(".header.scrolled").outerHeight();
        } else {
          position = $(`#page-${el.data("page")}-item-1`).offset().top - $(".header").outerHeight();
        }
          
        $("html, body").animate({ scrollTop: position }, 1000);

      }

      var pager = $(response).data("next-page");
      if (pager) {
        $(".events-show-more").attr("href", pager);
        $(".events-show-more").data("page", (el.data("page") + 1));
      } else {
        $(".events-show-more").remove();
      }
      _this.getInitialInstaces();
    });
    return false;
  },

  render: function () {
    this.getInitialInstaces();
    this.calendar();
    this.applySelectFilters();
  },
});

export default Filter;
